export const getGMapsDirectionsUrl = (lat: number, lon: number, address: string) => {
    return `https://www.google.com/maps/dir//${encodeURIComponent(address)}/@${lat},${lon}`;
};

export const getCookie = (name: string) => {
    const cookieName = name + '=';
    const cookieArr = document.cookie.split(';');
    return cookieArr.reduce((res, cookieItem) => {
        cookieItem = cookieItem.trim();
        if (cookieItem.indexOf(cookieName) === 0) {
            res = cookieItem.substring(cookieName.length, cookieItem.length);
        }
        return res;
    }, '');
};

export function getDayLabel(dayNum: number) {
    return new Date(1000 * 60 * 60 * 24 * (4 + dayNum)).toLocaleString('default', {
        weekday: 'long'
    });
}

export function formatBopisTime(timeStr: string) {
    const date = new Date();
    const hours = timeStr.slice(0, 2);
    const minutes = timeStr.slice(2, 4);
    date.setHours(parseInt(hours));
    date.setMinutes(parseInt(minutes));
    //TODO: get locale from config?
    return date.toLocaleTimeString('default', { hour: 'numeric', minute: 'numeric' });
}
